const options = {
	threshold: 0.5, // Trigger when 50% of the element is visible
};

const observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.remove('c-border--will-animate');
			observer.unobserve(entry.target); // Stop observing this element
		}
	});
}, options);

const elementsToObserve = document.querySelectorAll('.c-border--will-animate');

elementsToObserve.forEach((element) => {
	observer.observe(element);
});
